import React from "react";
import { PrefillInput } from "@components/input";

export const PostCode = () => (
  <PrefillInput
    title="Post code"
    placeholder="Post code"
    name="postCode"
    type="number"
    maxLength="4"
  />
);